import React from "react";
import { RuleValue } from "../types";
import AIRuleform, { UseAIValue } from "./AIRuleForm";
// import AutomationRuleForm, { UseAutomationValue } from "./AutomationRuleForm"; // Commented out - outdated
import AutoResolveChatRuleForm, {
  AutoResolveChatValue
} from "./AutoResolveChatRuleForm";
import CreateCrmRecordRuleForm, {
  CreateCrmRecordValue
} from "./CreateCrmRecordRuleForm";
// import LanguageConfigRuleForm, { LanguageConfigValue } from "./LanguageConfigRuleForm"; // Commented out - outdated
// import StyleConfigRuleForm, { StyleConfigValue } from "./StyleConfigRuleForm"; // Commented out - outdated
import WorkflowOnResolveRuleForm, {
  WorkflowOnResolveValue
} from "./WorkflowOnResolveRuleForm";
import SurveyRuleForm, { SurveyRuleFormValue } from "./SurveyRuleForm";
import WorkflowOnUnavailableRuleForm, {
  WorkflowOnUnavailableValue
} from "./WorkflowOnUnavailableRuleForm";
import ChatWindowRuleForm, { ChatWindowValue } from "./ChatWindowRuleForm";

interface Props {
  trigger: string;
  value: RuleValue;
  updateValue: (value: RuleValue) => void;
}

export default function RuleFormFactory({
  trigger,
  value,
  updateValue
}: Props) {
  switch (trigger) {
    case "":
      return <span>Please select a trigger</span>;
    case "use-ai":
      return (
        <AIRuleform updateValue={updateValue} value={value as UseAIValue} />
      );
    // case "use-automation": // Commented out - outdated
    //   return (
    //     <AutomationRuleForm
    //       updateValue={updateValue}
    //       value={value as UseAutomationValue}
    //     />
    //   );
    case "resolve-chat":
      return (
        <AutoResolveChatRuleForm
          updateValue={updateValue}
          value={value as AutoResolveChatValue}
        />
      );
    case "create-crm-record":
      return (
        <CreateCrmRecordRuleForm
          updateValue={updateValue}
          value={value as CreateCrmRecordValue}
        />
      );
    case "determine-chat-window":
      return (
        <ChatWindowRuleForm
          updateValue={updateValue}
          value={value as ChatWindowValue}
        />
      );
    // case "determine-language-config": // Commented out - outdated
    //   return (
    //     <LanguageConfigRuleForm
    //       updateValue={updateValue}
    //       value={value as LanguageConfigValue}
    //     />
    //   );
    // case "determine-style-config": // Commented out - outdated
    //   return (
    //     <StyleConfigRuleForm
    //       updateValue={updateValue}
    //       value={value as StyleConfigValue}
    //     />
    //   );
    case "use-workflow-on-resolve":
      return (
        <WorkflowOnResolveRuleForm
          updateValue={updateValue}
          value={value as WorkflowOnResolveValue}
        />
      );
    case "use-workflow-on-unavailable":
      return (
        <WorkflowOnUnavailableRuleForm
          updateValue={updateValue}
          value={value as WorkflowOnUnavailableValue}
        />
      );
    case "use-prechat-survey":
      return (
        <SurveyRuleForm
          updateValue={updateValue}
          value={value as SurveyRuleFormValue}
          label={"Display a survey before chat starts"}
        />
      );
    case "use-postchat-survey":
      return (
        <SurveyRuleForm
          updateValue={updateValue}
          value={value as SurveyRuleFormValue}
          label={"Display a survey after chat ends"}
        />
      );
    case "use-unavailable-survey":
      return (
        <SurveyRuleForm
          updateValue={updateValue}
          value={value as SurveyRuleFormValue}
          label={"Display a survey when chat is unavailable"}
        />
      );
    default:
      return <div>no form for {trigger}</div>;
  }
}
